import widgetModeImage from "@assets/imgs/widget-mode.png";
import { DSCheckbox } from "@components/design-system/molecules";
import { DSModal } from "@components/design-system/organisms/DSModal";
import { useLocalStorage } from "@hooks";
import { useState } from "react";

import { usePipState } from "./use-pip-state";

export const PipDialog = () => {
  const { isInPipMode } = usePipState();
  const [disableTutorial, setDisableTutorial] = useLocalStorage(
    "pip-disable-tutorial",
    false,
  );

  return (
    <PipDialogSession
      key={isInPipMode ? "pip-on" : "pip-off"}
      isInPipMode={isInPipMode}
      disableTutorial={disableTutorial}
      setDisableTutorial={setDisableTutorial}
    />
  );
};

function PipDialogSession({
  isInPipMode,
  disableTutorial,
  setDisableTutorial,
}) {
  const [isDismissed, setIsDismissed] = useState(false);
  const [localDisableTutorial, setLocalDisableTutorial] =
    useState(disableTutorial);

  const shouldShow = isInPipMode && !disableTutorial && !isDismissed;

  const handleClose = () => {
    setDisableTutorial(localDisableTutorial);
    setIsDismissed(true);
  };

  return (
    <DSModal
      isOpen={shouldShow}
      onClose={handleClose}
      title="You're in Widget Mode"
      width="w-[60vw] max-w-[600px]"
      dataTestId="pip-dialog-modal"
      actions={[
        {
          label: "Got It",
          variant: "primary",
          onClick: handleClose,
          dataTestId: "pip-dialog-got-it-button",
        },
      ]}
    >
      <h5 className="text-xs md:text-sm">
        Widget Mode allows you to{" "}
        <strong>
          switch over to your PIMS or medical record software
        </strong>{" "}
        to easily import your notes with this side-by-side view.
      </h5>
      <img
        src={widgetModeImage}
        alt="Widget Mode Image"
        className="max-w-[300px] mx-auto mb-2"
      />

      <h5 className="text-xs md:text-sm">
        Widget Mode will stay active as long as this browser page is
        open. To exit Widget Mode, simply click the "X" in the top
        right corner of the floating widget.
      </h5>

      <h5 className="py-2">
        <a
          href="https://docs.scribenote.com/en/articles/12602342"
          target="_blank"
          rel="noopener noreferrer"
          className="text-brand hover:text-indigo-800 dark:hover:text-indigo-300 underline transition-colors"
          data-mx-label="pip-learn-more"
        >
          Learn More
        </a>
      </h5>

      <div className="flex items-center gap-2 text-sm mt-2">
        <DSCheckbox
          id="pip-tutorial-disable-checkbox"
          size="sm"
          checked={localDisableTutorial}
          onChange={(e) => setLocalDisableTutorial(e.target.checked)}
          data-mx-label="pip-tutorial-disable-checkbox"
          dataTestId="pip-tutorial-disable-checkbox"
        />
        <label
          htmlFor="pip-tutorial-disable-checkbox"
          className="cursor-pointer"
        >
          Don't show this message again
        </label>
      </div>
    </DSModal>
  );
}
